var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title-bar'),_c('phieu-sua-chua',{on:{"onDialogRepairTimesheetSubmitted":_vm.handleDialogRepairTimesheetSubmitted}}),_c('tho-sua-chua',{attrs:{"type":"monthly"}}),_c('cham-cong',{attrs:{"reloadRepairTimesheetTable":_vm.reloadRepairTimesheetTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }